export default [
  { label: 'Казань', value: 'Казань', slug: 'KAZAN' },
  { label: 'Тольятти', value: 'Тольятти', slug: 'TOGLIATTI' },
]
